"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UI = void 0;
const Log_1 = __importDefault(require("@common/Log"));
class UI {
    static pushPage(pageId, options) {
        if (typeof options === "undefined") {
            options = {};
        }
        Log_1.default.trace("UI::pushPage( " + pageId + ", " + JSON.stringify(options) + " )");
        const nav = document.querySelector("#myNavigator");
        if (nav !== null) {
            return nav.pushPage(pageId, options);
        }
        else {
            Log_1.default.error("UI::pushPage(..) - WARN: nav is null");
        }
    }
    static getCurrentPage() {
        const nav = document.querySelector("#myNavigator");
        if (nav !== null) {
            return nav.topPage;
        }
    }
    static popPage(options) {
        const nav = document.querySelector("#myNavigator");
        if (nav !== null) {
            nav.popPage(options);
        }
        else {
            Log_1.default.error("UI::popPage(..) - WARN: nav is null");
        }
    }
    static notification(note) {
        ons.notification.alert(note);
    }
    static notificationConfirm(note, callback) {
        ons.notification.confirm({ message: note, callback });
    }
    static notificationToast(note, time = 5000) {
        ons.notification.toast({ message: note, timeout: time });
    }
    static handleError(err) {
        if (err instanceof Error) {
            ons.notification.alert(err.message);
        }
        else {
            ons.notification.alert(err);
        }
    }
    static showErrorToast(text) {
        ons.notification.toast({ message: text, buttonLabel: "Ok", modifier: "danger" });
    }
    static showSuccessToast(text, opts) {
        if (typeof opts === "undefined") {
            opts = {};
        }
        opts.message = text;
        if (typeof opts.timeout === "undefined") {
            opts.timeout = 2000;
        }
        if (typeof opts.force === "undefined") {
            opts.force = false;
        }
        if (typeof opts.buttonLabel === "undefined") {
        }
        ons.notification.toast(opts);
    }
    static createOption(text, value) {
        return ons.createElement("<option value=' + value + '>" + text + "</option>");
    }
    static createListItem(text, subtext, tappable) {
        let prefix = '<ons-list-item style="display: table;">';
        if (typeof tappable !== "undefined" && tappable === true) {
            prefix = '<ons-list-item style="display: table;" modifier="chevron" tappable>';
        }
        if (typeof subtext === "undefined") {
            const taskItem = ons.createElement("<ons-list-item>" + text + "</ons-list-item>");
            return taskItem;
        }
        else {
            const taskItem = ons.createElement(prefix +
                '<span class="list-item__title">' +
                text +
                "</span>" +
                '<span class="list-item__subtitle">' +
                subtext +
                "</span>" +
                "</ons-list-item>");
            return taskItem;
        }
    }
    static createListHeader(text) {
        const taskHeader = ons.createElement("<ons-list-header>" + text + "</ons-list-header>");
        return taskHeader;
    }
    static showModal(text) {
        if (typeof text === "undefined") {
            text = null;
        }
        const modals = document.querySelectorAll("ons-modal");
        for (const m of modals) {
            Log_1.default.trace("UI::showModal( " + text + " ) - start");
            if (m !== null) {
                if (text != null) {
                    const _content = document.querySelectorAll("#modalText");
                    const textFields = document.querySelectorAll("#modalText");
                    for (const t of textFields) {
                        t.innerHTML = text;
                    }
                }
                if (m.visible === false) {
                    m.show({ animation: "fade" });
                }
            }
            else {
                Log_1.default.error("UI::showModal(..) - Modal is null");
            }
        }
    }
    static showError(failure) {
        var _a;
        Log_1.default.error("UI::showError(..) - failure: " + JSON.stringify(failure));
        if (typeof failure === "string") {
            return UI.showAlert(failure);
        }
        else if (typeof ((_a = failure === null || failure === void 0 ? void 0 : failure.failure) === null || _a === void 0 ? void 0 : _a.message) === "string") {
            return UI.showAlert(failure.failure.message);
        }
        else if (typeof (failure === null || failure === void 0 ? void 0 : failure.message) === "string") {
            return UI.showAlert(failure.message);
        }
        else {
            Log_1.default.error("Unknown message: " + JSON.stringify(failure));
            return UI.showAlert("Action unsuccessful.");
        }
    }
    static getTextFieldValue(fieldName) {
        const field = document.querySelector("#" + fieldName);
        if (field !== null) {
            return field.value;
        }
        else {
            Log_1.default.error("UI::getTextFieldValue( " + fieldName + " ) - element does not exist");
        }
    }
    static getToggleValue(fieldName) {
        const field = document.querySelector("#" + fieldName);
        if (field !== null) {
            return field.checked;
        }
        else {
            Log_1.default.error("UI::getToggleValue( " + fieldName + " ) - element does not exist");
        }
    }
    static getDropdownValue(elementName) {
        const field = document.querySelector("#" + elementName);
        if (field !== null) {
            return field.options[field.selectedIndex].value;
        }
        else {
            Log_1.default.error("UI::getDropdownValue( " + elementName + " ) - element does not exist");
        }
    }
    static setDropdownSelected(elementName, value, editable) {
        const field = document.querySelector("#" + elementName);
        if (field !== null) {
            for (let i = 0; i < field.length; i++) {
                const opt = field.options[i];
                if (opt.value === String(value)) {
                    field.selectedIndex = i;
                }
            }
            if (editable === false) {
                field.setAttribute("readonly", "");
            }
        }
        else {
            Log_1.default.error("UI::setDropdownSelected( " + elementName + ", ... ) - element does not exist");
        }
    }
    static setDropdownOptions(elementName, options, selectedVal) {
        const selector = document.querySelector("#" + elementName);
        if (selector !== null) {
            selector.innerHTML = "";
            for (const opt of options) {
                let selected = false;
                if (typeof selectedVal !== "undefined" && selectedVal === opt) {
                    selected = true;
                }
                const o = new Option(opt, opt, false, selected);
                selector.add(o);
            }
        }
        else {
            Log_1.default.error("UI::setDropdownOptions( " + elementName + ", ... ) - element does not exist");
        }
    }
    static hideModal() {
        const modals = document.querySelectorAll("ons-modal");
        for (const m of modals) {
            if (m !== null) {
                Log_1.default.info("UI::hideModal(..) - hiding modal");
                m.hide({ animation: "fade" });
            }
            else {
                Log_1.default.error("UI::hideModal(..) - Modal is null");
            }
        }
    }
    static showAlert(message) {
        return ons.notification.alert(message);
    }
    static showHtmlDialog(title, html) {
        const markup = '<ons-dialog class="htmlDialog" cancelable>' +
            '<div class="htmlDialogHeader"><span class="htmlDialogTitle"></span>' +
            '<ons-button modifier="quiet" class="htmlDialogClose" aria-label="Close">&times;</ons-button></div>' +
            '<div class="htmlDialogBody"></div>' +
            "</ons-dialog>";
        return Promise.resolve(ons.createElement(markup, { append: true }))
            .then(function (dialog) {
            dialog.querySelector(".htmlDialogTitle").textContent = title;
            dialog.querySelector(".htmlDialogBody").innerHTML = html;
            dialog.querySelector(".htmlDialogClose").onclick = function () {
                dialog.hide();
            };
            dialog.addEventListener("posthide", function () {
                dialog.remove();
            });
            dialog.show();
        })
            .catch(function (err) {
            Log_1.default.error("UI::showHtmlDialog(..) - ERROR: " + err.message);
        });
    }
    static templateConfirm(template, options) {
        return ons
            .createElement(template, { append: true })
            .then(function (classlistDialog) {
            const onsList = classlistDialog.querySelector("ons-list");
            classlistDialog.querySelector("ons-list-header").innerHTML = options.header;
            classlistDialog.querySelector("ons-button").onclick = function () {
                classlistDialog.hide();
            };
            if (options === null || options === void 0 ? void 0 : options.listContent) {
                options.listContent.forEach(function (listItem) {
                    onsList.appendChild(UI.createListItem(listItem.text, listItem.subtext || ""));
                });
            }
            classlistDialog.show();
        })
            .catch(function (err) {
            Log_1.default.error("UI::prompt(..) - ERROR: " + err);
        });
    }
    static templateDisplayText(template_1) {
        return __awaiter(this, arguments, void 0, function* (template, text = "") {
            return ons.createElement(template, { append: true }).then(function (textDialog) {
                const textContentDiv = textDialog.querySelector("#adminDockerBuildDialog-logs-text");
                textContentDiv.innerText = text;
                textDialog.show();
                const saveButton = textDialog.querySelector("#adminDockerBuildDialog-footer-save");
                const closeButton = textDialog.querySelector("#adminDockerBuildDialog-footer-close");
                closeButton.onclick = function () {
                    textDialog.hide();
                };
                saveButton.onclick = function () {
                    const dateTimeLocal = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString();
                    saveButton.download = "Build Log " + dateTimeLocal + ".txt";
                    saveButton.href = "data:application/octet-stream," + encodeURIComponent(textContentDiv.innerText);
                };
                saveButton.download = "Classy Build Log";
                saveButton.oncontextmenu = function () {
                    saveButton.href = "data:application/octet-stream," + encodeURIComponent(textContentDiv.innerText);
                };
                return textContentDiv;
            });
        });
    }
    static confirm(message, options) {
        return ons.notification.confirm(message);
    }
    static took(start) {
        return Date.now() - start + " ms";
    }
    static showSection(id) {
        const el = document.getElementById(id);
        if (el === null) {
            Log_1.default.error("UI::showSection( " + id + " ) - unknown id");
        }
        else {
            el.style.display = "inherit";
        }
    }
    static hideSection(id) {
        const el = document.getElementById(id);
        if (el === null) {
            Log_1.default.error("UI::hideSection( " + id + " ) - unknown id");
        }
        else {
            el.style.display = "none";
        }
    }
    static injectCustomPage(path) {
        Log_1.default.info("UI::injectCustomPage( " + path + " ) - start");
        const importNode = document.createElement("link");
        importNode.href = path;
        importNode.rel = "import";
        importNode.onload = function (importedNode, event) {
            Log_1.default.info("UI::injectCustomPage( " + path + " ) - loading complete");
            importNode.import = event.target.import;
        }.bind(this, importNode);
        document.head.appendChild(importNode);
    }
    static cloneCustomElement(id) {
        Log_1.default.info("UI::cloneCustomElement( " + id + " ) - start");
        const customs = document.querySelectorAll('link[rel="import"]');
        for (const custom of Array.from(customs)) {
            if (custom !== null) {
                const templates = custom.import.querySelectorAll("template");
                for (const template of Array.from(templates)) {
                    if (template !== null && template.id === id) {
                        const clone = document.importNode(template.content, true);
                        return clone;
                    }
                }
            }
        }
        return null;
    }
    static clearChildren(id) {
        const el = document.getElementById(id);
        if (el === null) {
            Log_1.default.error("UI::clearChildren( " + id + " ) - unknown id");
        }
        else {
            el.innerHTML = "";
        }
    }
    static clearTextField(fieldName) {
        const field = document.querySelector("#" + fieldName);
        if (field !== null) {
            field.value = "";
        }
        else {
            Log_1.default.error("UI::clearTextField( " + fieldName + " ) - element does not exist");
        }
    }
}
exports.UI = UI;
UI.inputTypes = { TIMEDATE: "timeDate", NUMBER: "number", TEXT: "text" };
UI.ons = ons;
